<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';
import ReportGenerateDialogHeader from '@/components/headers/ReportGenerateDialogHeader.vue';
import PageDialogWrapper from '@/components/wrappers/PageDialogWrapper.vue';

import dialog from '@/styles/jobEditDialog.module.scss';

export interface Props {
  lockedBy?: string;
}
export type DefProps = typeof props;

const props = withDefaults(defineProps<Props>(), {
  lockedBy: 'another user',
});

const emit = defineEmits<{
  okayBtnClick: [event: Event];
}>();

function handleOkayClick(event: Event): void {
  emit('okayBtnClick', event);
}
</script>

<template>
  <PageDialogWrapper
    :class="[$style.jobEditLockedByOtherDialog, dialog.dialogRoot]"
    data-testid="jobEditLockedByOtherDialog"
  >
    <template #header>
      <ReportGenerateDialogHeader :show-close-btn="false">
        Job is Locked
      </ReportGenerateDialogHeader>
    </template>

    <section>
      <div :class="dialog.text">
        This job is currently being edited by
        <strong>{{ props.lockedBy }}</strong
        >. Please try again later.
      </div>
    </section>

    <template #footer>
      <menu :class="dialog.dialogFooterMenuList">
        <li :class="dialog.dialogFooterMenuListItem">
          <KBtn append-icon="mdi-check" @click="handleOkayClick"> Okay </KBtn>
        </li>
      </menu>
    </template>
  </PageDialogWrapper>
</template>

<style module lang="scss">
.jobEditLockedByOtherDialog {
}
</style>
